import styled from "styled-components";
import { Image } from "react-bootstrap";

export const HeaderLogoLink = styled.a``;

export const HeaderLogoImage = styled(Image)`
  cursor: pointer;
  width: 121px;
`;
